var requireNonNull = require('util/require-non-null');

/**
 * Wrapper for CommandScriptResults.
 */
function SecurityCommandScriptResult(errors) {
    this.errors = requireNonNull(errors);
}

SecurityCommandScriptResult.prototype.toString = function() {
    return "SecurityCommandScriptResult [" + this.errors + "]";
};

module.exports = SecurityCommandScriptResult;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/authentication/security-command-script-result.js
// module id = 191
// module chunks = 1